import { render, staticRenderFns } from "./image-gradient-opacity.vue?vue&type=template&id=3b228357&"
import script from "./image-gradient-opacity.vue?vue&type=script&lang=js&"
export * from "./image-gradient-opacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports